import { createScopedRowsClient } from "#ce/shared/filters/api/scoped-rows-client";

function rowsOf(payload) {
  return Array.isArray(payload) ? payload : [];
}

/**
 * Returns the data source for the visit-type options served under `visit_types`. Unparsed: the
 * facet reads `text`, `value`, `visible`, `parent` and `category` off plain objects and builds
 * its own item tree.
 *
 * @param {Object} [options]
 * @param {String} [options.url] - The endpoint serving the options. Without one, `all` rejects: the
 *   client names no route of its own.
 */
export const createVisitTypeFilterApi = (options = {}) => {
  const { url } = options;

  if (!url) {
    return {
      all: async () => {
        throw new Error("createVisitTypeFilterApi: no `url` configured for the visit-type options");
      },
    };
  }

  return createScopedRowsClient({
    url,
    readRows: rowsOf,
    clientOptions: { root: "visit_types" },
  });
};
